
import { useApparelData } from './apparelShop/useApparelData';
import { useApparelCart } from './apparelShop/useApparelCart';
import { ApparelContextType, CartItem } from '@/types/apparelTypes';
import { useState, useEffect, useMemo } from 'react';

export const useApparelShop = (isParentPortal = false): ApparelContextType => {
  const { 
    products, 
    categories, 
    families, 
    students, 
    loading,
    error,
    refreshProducts
  } = useApparelData(isParentPortal);

  const {
    cart,
    selectedProduct,
    detailsOpen,
    cartOpen,
    checkoutOpen,
    setDetailsOpen,
    setCartOpen,
    setCheckoutOpen,
    handleProductSelect,
    addToCart,
    handleRemoveFromCart,
    handleUpdateQuantity,
    handleUpdateSize,
    handleCheckout,
    handleOrderSuccess,
    getTotalItems,
    cartSubtotal,
    clearCart,
  } = useApparelCart();

  // Calculate cart count with memoization to ensure it updates
  const cartCount = useMemo(() => {
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  }, [cart]);

  return {
    // Data properties
    products,
    categories,
    families,
    students,
    loading,
    error,
    
    // Cart state
    cartItems: cart, // Alias cart to cartItems
    cart, // Original property name
    selectedProduct,
    detailsOpen,
    cartOpen,
    checkoutOpen,
    
    // Setter functions
    setDetailsOpen,
    setCartOpen,
    setCheckoutOpen,
    
    // Action handlers
    handleProductSelect,
    addToCart,
    removeFromCart: handleRemoveFromCart, // Match the expected interface
    updateQuantity: handleUpdateQuantity, // Match the expected interface
    updateSize: handleUpdateSize, // Match the expected interface
    handleRemoveFromCart,
    handleUpdateQuantity,
    handleUpdateSize,
    handleCheckout,
    handleOrderSuccess,
    clearCart,
    
    // Helper methods
    cartItemCount: cartCount, // Use the state variable that updates in real time
    getTotalItems,
    cartSubtotal, // Function reference
    refreshProducts,
    isParentPortal
  };
};

export type { CartItem } from '@/types/apparelTypes';
